import React, { useContext, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import axios from "axios";
import { backend_url } from "../../App";
import { ShopContext } from "../../Context/ShopContext";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./Hero.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// Picks a real, uncluttered product photo for the banner instead of relying on
// a manually uploaded graphic — read-only, never touches product data.
const pickBannerImage = (banner, products) => {
  if (!products?.length) return banner.image;

  const inCategory = products.filter(
    (p) => p.subcategory?.toLowerCase().trim() === banner.routeTo?.toLowerCase().trim()
  );
  const bestsellerInCategory = inCategory.find((p) => p.bestseller?.toLowerCase() === "yes");
  const anyBestseller = products.find((p) => p.bestseller?.toLowerCase() === "yes");

  const chosen = bestsellerInCategory || inCategory[0] || anyBestseller || products[0];
  return chosen?.images?.[0] || banner.image;
};

const Hero = () => {
  const [banners, setBanners] = useState([]);
  const { products } = useContext(ShopContext);
  const swiperRef = useRef(null);

  useEffect(() => {
    fetchBanners();
  }, []);

  const fetchBanners = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/landingbanner`);
      setBanners(response.data);
    } catch (error) {
      console.error("Error fetching banners:", error);
    }
  };

  // ─── BACKUP: split-layout hero with text overlay + circular product photo ───
  // This was tried and reverted. Restore this (and remove the plain-image
  // return below) to bring back the text/badge/CTA + circular-photo design.
  //
  // return (
  //   <div className="relative w-full hero-split">
  //     <Swiper
  //       modules={[Navigation, Pagination, Autoplay]}
  //       slidesPerView={1}
  //       pagination={{ clickable: true }}
  //       autoplay={{ delay: 4000 }}
  //       loop={banners.length > 1}
  //       onSwiper={(swiper) => (swiperRef.current = swiper)}
  //       className="hero-split-swiper"
  //     >
  //       {banners.map((banner) => (
  //         <SwiperSlide key={banner._id}>
  //           <Link
  //             to={`collections/${banner.routeTo}`}
  //             className="hero-split-slide"
  //             onClick={(e) => {
  //               if (swiperRef.current?.animating) {
  //                 e.preventDefault();
  //               }
  //             }}
  //           >
  //             <div className="hero-split-text">
  //               <span className="hero-split-badge">
  //                 {banner.badgeText || "New Arrival"}
  //               </span>
  //               <h1 className="hero-split-title">
  //                 {banner.title || "Timeless Fabrics, Modern Style"}
  //               </h1>
  //               <p className="hero-split-subtitle">
  //                 {banner.subtitle || "Crafted with care, made for every occasion"}
  //               </p>
  //               <span className="hero-split-cta">
  //                 {banner.ctaText || "Shop Now"}
  //                 <span className="hero-split-cta-arrow">→</span>
  //               </span>
  //             </div>
  //             <div className="hero-split-photo">
  //               <div className="hero-split-photo-ring">
  //                 <img
  //                   crossOrigin="anonymous"
  //                   src={pickBannerImage(banner, products)}
  //                   alt={banner.category}
  //                 />
  //               </div>
  //               {banner.discountText && (
  //                 <span className="hero-split-discount">
  //                   {banner.discountText}
  //                 </span>
  //               )}
  //               {banner.secondaryImage && (
  //                 <span className="hero-split-photo-secondary">
  //                   <img
  //                     crossOrigin="anonymous"
  //                     src={banner.secondaryImage}
  //                     alt=""
  //                   />
  //                 </span>
  //               )}
  //             </div>
  //           </Link>
  //         </SwiperSlide>
  //       ))}
  //     </Swiper>
  //     {banners.length > 1 && (
  //       <>
  //         <button
  //           className="absolute left-2 sm:left-4 top-1/2 z-30 transform -translate-y-1/2
  //                  bg-white text-[var(--brand-primary-600)] p-2 sm:p-3 rounded-full shadow-md
  //                  hover:bg-[var(--brand-primary-700)] hover:text-white transition duration-300"
  //           onClick={(e) => {
  //             e.preventDefault();
  //             e.stopPropagation();
  //             swiperRef.current?.slidePrev();
  //           }}
  //         >
  //           <FaChevronLeft size={16} />
  //         </button>
  //         <button
  //           className="absolute right-2 sm:right-4 top-1/2 z-30 transform -translate-y-1/2
  //                  bg-white text-[var(--brand-primary-600)] p-2 sm:p-3 rounded-full shadow-md
  //                  hover:bg-[var(--brand-primary-700)] hover:text-white transition duration-300"
  //           onClick={(e) => {
  //             e.preventDefault();
  //             e.stopPropagation();
  //             swiperRef.current?.slideNext();
  //           }}
  //         >
  //           <FaChevronRight size={16} />
  //         </button>
  //       </>
  //     )}
  //   </div>
  // );

  return (
    <div className="relative w-full hero bg-white max-md:px-3">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={50}
        slidesPerView={1}
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        loop={true}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        allowSlideNext={true}
        allowSlidePrev={true}
        className="hero-swiper"
        style={{ marginBottom: "8px", marginTop: "4px" }}
      >
        {banners.map((banner) => (
          <SwiperSlide key={banner._id}>
            <Link
              to={`/collections/${banner.routeTo}`}
              onClick={(e) => {
                if (swiperRef.current?.animating) {
                  e.preventDefault();
                }
              }}
            >
              <img crossOrigin="anonymous"
                src={`${banner.image}`}
                alt={banner.category}
                className="w-full h-auto object-contain object-center rounded-lg bg-white max-md:rounded-2xl max-md:shadow-[0_8px_24px_rgba(124,58,237,0.18)]"
              />
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>

      <button
        className="absolute left-2 sm:left-4 top-1/2 z-30 transform -translate-y-1/2
               bg-white text-[var(--brand-primary-600)] p-2 sm:p-3 rounded-full shadow-md
               hover:bg-[var(--brand-primary-700)] hover:text-white transition duration-300"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          swiperRef.current?.slidePrev();
        }}
      >
        <FaChevronLeft size={16} />
      </button>

      <button
        className="absolute right-2 sm:right-4 top-1/2 z-30 transform -translate-y-1/2
               bg-white text-[var(--brand-primary-600)] p-2 sm:p-3 rounded-full shadow-md
               hover:bg-[var(--brand-primary-700)] hover:text-white transition duration-300"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          swiperRef.current?.slideNext();
        }}
      >
        <FaChevronRight size={16} />
      </button>
    </div>
  );
};

export default Hero;
